import React from 'react';
import Edit from '../../rest/Edit';
import Form from '../components/Form';

const PermissionsEdit = props => (
  <Edit {...props} resource="permissions">
    <Form />
  </Edit>
);

PermissionsEdit.propTypes = {};

export default PermissionsEdit;
